/**
 * Whether a pack's cells travel to the wall — one predicate for the grid's cells and the stage's
 * look door (plan 2026_09_23_pack_stage_coda.md § Decided 3).
 *
 * All-or-nothing on purpose: a surface where some cells travel to the wall and others silently
 * select the stage would be one affordance wearing two behaviours. A pack not yet ingested into
 * `wall_tiles` keeps the shipped selection whole.
 */
export function cellsTravel(tileIds: readonly (number | null)[]): boolean {
    return tileIds.length > 0 && tileIds.every((id) => id !== null)
}

/** The wall tile for cell `i`, or null when the pack's cells do not travel. */
export function tileIdAt(tileIds: readonly (number | null)[], i: number): number | null {
    return cellsTravel(tileIds) ? (tileIds[i] ?? null) : null
}
